import { useQuery } from "react-query";
import instance from "../axios";

const getCompaniesRequest = async (roomId, lang) => {
  try {
    const response = await instance.get(`/${roomId}/activities/companies`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        lang: lang,
      },
    });

    // console.log(response.data, "comps");
    return response.data;
  } catch (error) {
    console.log(error, "get companies");
  }
};

export const GetCompanies = (roomId, lang) => {
  return useQuery(`get-companies-${lang}`, () =>
    getCompaniesRequest(roomId, lang)
  );
};

const getCategoriesRequest = async (roomId, companyId, lang) => {
  try {
    const response = await instance.get(
      `/${roomId}/activities/categories/${companyId}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          lang: lang,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.log(error, "error activities");
  }
};

export const GetActivitiesCategories = (roomId, companyId, lang) => {
  return useQuery(`get-activities-categories-${lang}`, () =>
    getCategoriesRequest(roomId, companyId, lang)
  );
};

const getActivitiesCategoryRequest = async (
  roomId,
  companyId,
  categoryId,
  lang
) => {
  try {
    const response = await instance.get(
      `/${roomId}/activities/category-activities/${companyId}/${categoryId}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          lang: lang,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.log(error, "error category-activities");
  }
};

export const GetCategoryActivities = (roomId, companyId, categoryId, lang) => {
  return useQuery(
    `activity-category-${roomId}-${companyId}-${categoryId}-${lang}`,
    () => getActivitiesCategoryRequest(roomId, companyId, categoryId, lang)
  );
};
